export const honeybeeCategories = [
  "All",
  "Entrance",
  "Living Room",
  "Living Room 2",
  "Kitchen",
  "Kitchen 2",
  "Bedroom 1",
  "Bedroom 2",
  "Bathroom",
  "Outdoor",
  "Outdoor 2",
  "Outdoor 3",
  "Extra"
];

export const honeybeeImages: { url: string; title: string; category: string }[] = [
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/7b0e511856c90691100fc8175bd3d712.jpeg",
    title: "Entrance with Bee Artwork and Vanity",
    category: "Entrance"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/d7aa89527c8c033110903407ff21e028.jpeg",
    title: "Living Room with Bee Kind Chairs",
    category: "Living Room"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/f38d21d489e3e6e9def27d63a81a62e9.jpeg",
    title: "Living Room with Cozy Beige Sofa",
    category: "Living Room 2"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/cb38300d9fe4785ee8f5556356e1e71f.jpeg",
    title: "Kitchen with White Cabinets",
    category: "Kitchen"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/1f3d9c41ff82ecfee6306020b33a8c02.jpeg",
    title: "Kitchen Dining Area with Farmhouse Table",
    category: "Kitchen 2"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/02b86df52315f04b997b70b5fe10ccde.jpeg",
    title: "Bedroom 1 with Door County Art",
    category: "Bedroom 1"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/d909c5f984b42f49856bd10b74aac46a.jpeg",
    title: "Bedroom 2 with Bee Pillow",
    category: "Bedroom 2"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/b8992773c1f464f0ef1234415300397c.png",
    title: "Bathroom with Subway Tile",
    category: "Bathroom"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/ef573c86cd7fc697bbea97d4fba9cdcf.png",
    title: "Outdoor Garden with Colorful Flowers",
    category: "Outdoor"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/b1174265b9998d6a422c499493cb4884.jpeg",
    title: "Cottage Front with Blooming Garden",
    category: "Outdoor 2"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/dc62005baeb2c92bab42a8f322731677.jpeg",
    title: "Flowering Tree with Spring Blooms",
    category: "Outdoor 3"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/f6721bffb24cf95f0f55f62716d36779.jpeg",
    title: "Door County Coffee Welcome Basket",
    category: "Extra"
  }
];
